import React, { useState, useRef } from 'react';
import { useTranslation } from '../../commons/useTranslasion';
import { Container, CurrentLanguage, LanguageList, LanguageOption } from './styles';

const languages = [
    {
        code: 'pt-br',
        name: 'Português',
        flag: 'https://flagcdn.com/w20/br.png'
    },
    {
        code: 'es-ar',
        name: 'Español',
        flag: 'https://flagcdn.com/w20/ar.png'
    }
];

const LanguageSelector: React.FC = () => {
    const { language, changeLanguage } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const currentLanguage = languages.find(lang => lang.code.toLowerCase() === language?.toLowerCase()) || languages[0];

    const handleLanguageChange = (languageCode: string) => {
        if (languageCode.toLowerCase() !== language?.toLowerCase()) {
            changeLanguage(languageCode);
        }
        setIsOpen(false);
    };

    return (
        <Container>
            <CurrentLanguage onClick={() => setIsOpen(!isOpen)}>
                <img 
                    src={currentLanguage.flag} 
                    alt={currentLanguage.name}
                    loading="lazy"
                />
            </CurrentLanguage>

            <LanguageList isOpen={isOpen}>
                {languages.map((lang) => (
                    <LanguageOption
                        key={lang.code}
                        onClick={() => handleLanguageChange(lang.code)}
                    >
                        <img 
                            src={lang.flag} 
                            alt={lang.name}
                            loading="lazy"
                        />
                        <span>{lang.name}</span>
                    </LanguageOption>
                ))}
            </LanguageList>
        </Container>
    );
};

export default LanguageSelector;
